
import { Component, Model, Prop, Vue, Watch } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import Dialog from '../dialog.vue';
import system from './system.vue'
import classification from './classification.vue'
import commodity from './commodity.vue'
import customize from './customize.vue'
import marketingActive from './marketingActive.vue'
import appletLink from './appletLink.vue'
import live from './live.vue'
import coupon from './coupon.vue'
import {
	pagetypelist
} from "@/utils/config"
@Component({
	name: '',
	components: {
		PageFooter,
		'slz-dialog': Dialog,
		system,
		classification,
		commodity,
		customize,
		marketingActive,
		appletLink,
		live,
		coupon
	}
})

export default class ProductList extends Vue {
	@Model('change') show!: boolean
	@Prop({ default: {} }) choosemsg!: any
	private dialogshow = false
	private pagetype = 1
	private pagetypelist: any = pagetypelist
	private currentMsg = {}
	@Watch('show')
	private getshow(e) {
		this.dialogshow = e
		if (e) {
			this.pagetypelist = this.pagetypelist.filter(v => {
				return !v.showPage || v.showPage.includes(this.$route.path)
			})
			this.pagetype = this.choosemsg.pagetype || 1
			if (!this.pagetypelist.find(v => v.value == this.pagetype)) {
				this.pagetype = 1
			}

		}
	}


	private chnageRadio(e) {
		this.currentMsg = this.pagetypelist.find(v => v.value == e)
	}
	private getmsg(num) {
		if (num == this.choosemsg.pagetype) {
			return this.choosemsg
		}
		return {}
	}
	private async save() {
		try {
			let ref = this.pagetypelist.find(v => v.value == this.pagetype).ref
			let choosemsg = await (this as any).$refs[ref].returnchoosemsg()
			if (this.pagetype == 6) {
				if (!choosemsg.IsJumpExternalWxApp) {
					choosemsg.ExternalWxAppId = ''
					choosemsg.ExternalWxAppOriginalId = ''
				} else {
					if (!choosemsg.ExternalWxAppId) {
						this.$message.error('请输入小程序appid')
						return
					}
					if (!choosemsg.ExternalWxAppOriginalId) {
						this.$message.error('请输入小程序原始id')
						return
					}
				}
				if (!choosemsg.JumpPageName) {
					this.$message.error('请输入页面名称')
					return
				}
				if (!choosemsg.JumpPath) {
					this.$message.error('请输入小程序页面路径')
					return
				}
			} else if (this.pagetype == 13) {
				console.log(choosemsg)
				if (!choosemsg?.Id) {
					this.$message.error('请选择优惠券')
					return
				}
			} else {
				if (!choosemsg || choosemsg.Id < 0) {
					this.$message.error('请选择链接')
					return
				}
			}
			let data: any = {
				...choosemsg,
				Id: choosemsg.Id,
				name: '',
				pagetype: this.pagetype,
				pagetypelabel: this.pagetypelist.find(v => v.value == this.pagetype).label,
				label: '',
				subdivideType: choosemsg.Type,
				subdivideTypeValue: choosemsg.TypeValue,

			}
			if (this.pagetype == 1) {
				// console.log(choosemsg)
				data = {
					...data,
					...choosemsg,
					label: choosemsg.label
				}
			} else if (this.pagetype == 2) {
				data.pageurl = 'pages/mall/category/category?id=' + data.Id
				data = {
					...data,
					CategoryName: choosemsg.CategoryName,
					ImgUrl: choosemsg.ImgUrl,
					ImgUrlComplete: choosemsg.ImgUrlComplete,
					label: choosemsg.CategoryName
				}
			} else if (this.pagetype == 3) {
				data.pageurl = 'pages/mall/detail/detail?id=' + data.Id
				data = {
					...data,
					ProductName: choosemsg.ProductName,
					ImgUrl: choosemsg.ImgUrl,
					ImgUrlComplete: choosemsg.ImgUrlComplete,
					SellPoint: choosemsg.SellPoint,
					label: choosemsg.ProductName
				}
			} else if (this.pagetype == 4) {
				data.pagetypelabel = '页面'
				data.pageurl = 'pageA/pages/customPage/customPage?id=' + data.Id
				data = {
					...data,
					PageName: choosemsg.PageName,
					label: choosemsg.PageName
				}
			} else if (this.pagetype == 5) {
				data.pagetypelabel = data.subdivideTypeValue
				if (data.subdivideType == 1) {
					data.pageurl = 'pageA/pages/mine/truntable/truntable?id=' + data.Id
				} else if (data.subdivideType == 2) {
					data.pageurl = 'pageA/pages/mine/sign-in/sign-in?id=' + data.Id
				} else if (data.subdivideType == 3) {
					data.pageurl = 'pageA/pages/mine/task-detail/task-detail?id=' + data.Id
				} else if (data.subdivideType == 4) {
					data.pageurl = 'pageB/pages/invite-friends/detail?id=' + data.Id
				} else if (data.subdivideType == 5) {
					data.pageurl = 'pageB/pages/koi-raffle/home?id=' + data.Id
				}
				data = {
					...data,
					PageName: choosemsg.Name,
					label: choosemsg.Name
				}
			} else if (this.pagetype == 6) {
				data.pagetypelabel = '小程序链接'
				data = {
					...data,
					PageName: choosemsg.JumpPageName,
					label: choosemsg.JumpPageName,
					pageurl: choosemsg.JumpPath
				}
			} else if (this.pagetype == 12) {
				if (data.Id) {
					data.pageurl = `plugin-private://wx2b03c6e691cd7370/pages/live-player-plugin?room_id=${data.RoomId}`;
				} else {
					data.pageurl = '';
				}


				//StartTime和EndTime会和图片导航模块里的startTime、endTime冲突
				data = {
					...data,
					PageName: choosemsg.Name,
					label: choosemsg.Name
				}
			}
			else if (this.pagetype == 13) {
				//StartTime和EndTime会和图片导航模块里的startTime、endTime冲突
				data = {
					...data,
					PageName: choosemsg.CouponName,
					label: choosemsg.CouponName
				}
			}

			console.log(data)
			data.StartTime = '';
			data.EndTime = '';
			data.PageUrl = data.pageurl;
			console.log(data)
			this.$emit('getdata', data)

		} finally {
			//
		}
	}
	private cancel() {
		this.dialogshow = false
		this.$emit('close')
	}
}
